/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//$(".Footer__Copyright").hide();
//$(".Footer__Aside").css("display","none");

if($(".Footer__Aside").children().length == 0)
  $(".Footer__Aside").hide();
else
  $(".Footer__Aside").show();
  

jQuery(function($){

  $('.shop-look-banner .ShopTheLook__Dot').click(function(){
    var tab_id = $(this).attr('data-product-index');    
    $(this).addClass('is-active');
    $('#'+tab_id).addClass('active');
    $('.shop-look-banner .ShopTheLook__Inner').addClass('open-product');
  });
  
  $('.shop-look-banner .ShopTheLook__ProductItem .close').click(function(){
    $('.shop-look-banner .ShopTheLook__ProductItem').removeClass('active');
    $('.shop-look-banner .ShopTheLook__Inner').removeClass('open-product');
  });

});  

jQuery(document).ready(function($){
  $('select').find('.loadselect').removeAttr('selected','selected');
  $('select').find('.loadselect').addClass('selected');
});